import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStudentCredentialsData, IGetStudentCredentialsVars } from '../types';

export const GET_STUDENT_CREDENTIALS: TypedDocumentNode<IGetStudentCredentialsData, IGetStudentCredentialsVars> = gql`
  query getStudentCredentials($input: ReadStudentCredentialsInput!) {
    readStudentCredentials(input: $input) {
      username
      password
    }
  }
`;
